import {combineReducers} from 'redux';
import productSearch from '../productSearch/productSearchReducer';
import stationSearch from '../stationSearch/stationSearchReducer';

const rootReducer = combineReducers({
  productSearch,
  stationSearch
});

export default rootReducer;